export default "<app-alergy-list></app-alergy-list>\r\n";